import { BundleId, AmdDependencies, AnyFunction } from '@mecontrol/common';
import { queueBundle } from './queue';

export function meDefine(id: BundleId, factory: AnyFunction): void;
export function meDefine(id: BundleId, deps: AmdDependencies[], factory: AnyFunction): void;
export function meDefine(id: BundleId, depsOrFactory: AmdDependencies[] | AnyFunction, possibleFactory?: AnyFunction): void {
    let deps: AmdDependencies[];
    let factory: AnyFunction;
    if (typeof depsOrFactory === 'function') {
        deps = [];
        factory = depsOrFactory;
    }
    else {
        deps = depsOrFactory;
        factory = possibleFactory as AnyFunction;
    }

    queueBundle(id, deps, factory);
}
